import { resolveFunnelVersions } from '../utils/funnelVersions';

export function useVersions() {
  const {
    $setVersions,
    $getQuiz,
    $mixpanel,
    $logger,
  } = useNuxtApp();
  const route = useRoute();
  const funnelConfig = useFunnelConfig();
  const expId = ref<string>();
  const variationName = ref<string>();

  async function generateFunnel(): Promise<void> {
    const funnelKey = useFunnelName(route.query.funnel);
    $mixpanel?.people.set({ Funnel: funnelKey });

    try {
      const store = useKegelAnalyticStore();
      const versions = resolveFunnelVersions(route.query, funnelKey, funnelConfig.value, store.versions);

      const result = await $setVersions(versions);
      if ($getQuiz) {
        await $getQuiz(result.quiz);
      }
    } catch (error) {
      $logger.error(error as Error, {
        tags: {
          flow: 'funnel',
          step: 'generate_funnel',
        },
        extra: {
          funnelKey,
          routeQuery: route.query,
        },
      });
    }
  }

  const experimentId = computed(() => expId.value);
  const variation = computed(() => variationName.value);

  return {
    generateFunnel,
    experimentId,
    variation,
  };
}
